import * as React from 'react';
import type {
  FiltersTemperatureControl,
  PaginationControl,
} from 'hooks/store/temperature-control/use-temperature-control-search-params';
import type { TTraceabilityEvent } from 'contracts/TraceabilityEvent';
import type { Pagination } from 'contracts/Pagination';
import { api, applyQueryString, handleApiError } from 'services/api';

type Payload = {
  filters?: FiltersTemperatureControl;
};

type Response = {
  data: TTraceabilityEvent[];
};

export const useFetchReportTemperatureControl = () => {
  const fetchReportTemperatureControl = React.useCallback(
    async (payload: Payload) => {
      const url = applyQueryString('/traceability-events', {
        ...payload.filters,
		all: true,
      });

      try {
        const { data } = await api.get<Response>(url);
        return data;
      } catch (e) {
        throw handleApiError(e);
      }
    },
    []
  );

  return {
    fetchReportTemperatureControl,
  };
};
